var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-area"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.getImgUrl('objetos-31.png'),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }